import angular from 'angular';
import {
  loaderService,
  pmDataService,
  pmSharedModelService,
  ssDialogService,
} from 'app/services';
import {
  confirmDialog,
  ssListItem
} from 'app/components/global';

import editSectionDialog from '../activeDocument/section/dialog.editSectionDialog';
import editEndnoteDialog from './dialog.editEndnoteDialog';
import deleteEndnoteConfirmDialog from './dialog.deleteEndNoteConfirmDialog';
import template from './edit-endnotes-dialog.html';
import controller from './edit-endnotes-dialog.controller';

class dialogService {
  getOptions($event, { endnotes, permissions, policyDocumentId, }) {
    return {
      controller,
      controllerAs: 'editEndnotesDialogVM',
      locals: {
        endnotes,
        permissions,
        policyDocumentId,
      },
      bindToController: true,
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.pm.editEndnotesDialog', [
  confirmDialog,
  editEndnoteDialog,
  editSectionDialog,
  deleteEndnoteConfirmDialog,
  loaderService,
  pmDataService,
  pmSharedModelService,
  ssListItem,
  ssDialogService,
])
  .service('editEndnotesDialog', dialogService)
  .name;
